// MODULES
import React from "react";

// HELPERS
import {createClassName} from "@helpers/utils";
import fulfillmentCheck from "./Fees.fulfillment";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import EditableField from "../../../components/EditableField/EditableField";
import FieldsCollection from "../../../../../components/FieldsCollection/FieldsCollection";
import * as CobHelpers from "../../../Cob.helpers";
import NumberField from "../../../components/NumberField/NumberField";


export default class Fees extends React.PureComponent
{
	static companyExclusive = false;
	static privateExclusive = false;

	static fields = _getFields();
	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState)
	{
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields)
		{
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}

	render()
	{
		const {props, state} = this;
		const {title} = props;

		const classes = createClassName("Cob-Fees", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled
		});

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields} />

				<div className="Cob-Fields">
					<h2>{title}</h2>

					<FieldsCollection
						fieldsPerRow={3}
						fields={[
							{
								render: (
									<EditableField
										name="futur_fee_premie"
										Component={NumberField}
										label="Premieavgift"
										value={state.fields.futur_fee_premie}
										valid={state.validFields.futur_fee_premie}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										unit={"%"}
										required
									/>
								)
							}, {
								render: (
									<EditableField
										name="futur_fee_kapital"
										Component={NumberField}
										label="Kapitalavgift"
										value={state.fields.futur_fee_kapital}
										valid={state.validFields.futur_fee_kapital}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										unit={"%"}
										required
									/>
								)
							}, {
								render: (
									<EditableField
										name="futur_fee_fast"
										Component={NumberField}
										label="Fast avgift"
										value={state.fields.futur_fee_fast}
										valid={state.validFields.futur_fee_fast}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										unit={"kr"}
										required
									/>
								)
							}
						]}
					/>
				</div>
			</div>
		);
	}

	_fieldValidator = (name, value) =>
	{
		return value.length > 0;
	};

	_onFieldChange = (name, value) =>
	{
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldBlur = (name) =>
	{
		CobHelpers.onViewFieldBlur.call(this, name);
	};
}

function _getFields()
{
	return [
		"futur_fee_premie",
		"futur_fee_kapital",
		"futur_fee_fast"
	];
}

function _getInitialState()
{
	if (this.props.prevState)
	{
		return {...this.props.prevState};
	}

	return {
		validFields: {},
		fields: {
			futur_fee_premie: "",
			futur_fee_kapital: "",
			futur_fee_fast: ""
		}
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/Fees/Fees.js